import { Box, Button, Modal, Typography } from "@mui/material";
import { useSuperAdminOrganization } from "../../../context/SuperAdmin/OrganizationContext";

const DeleteOrgModal = () => {
  const { isDeleting, assignToDeleteOrg, handleDelete, toDeleteOrg } =
    useSuperAdminOrganization();

  const handleClose = () => {
    if (!isDeleting) {
      assignToDeleteOrg("");
    }
  };

  return (
    <Modal
      open={Boolean(toDeleteOrg)}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0, 0, 0, 0.3)", // Fondo negro con opacidad
      }}
    >
      <Box
        component={"div"}
        sx={{
          width: 400,
          bgcolor: "background.paper", // Fondo blanco del modal
          borderRadius: 2, // Bordes redondeados
          p: 4,
          boxShadow: 24,
          minWidth: "600px",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
      >
        <Typography component={"h3"} sx={{ fontSize: "20px", fontWeight: 600 }}>
          ¿Quieres eliminar esta organización?
        </Typography>
        <Typography component={"p"}>
          Todas sus suscripciones y roles serán eliminados
        </Typography>
        <Box
          sx={{
            textAlign: "right",
            display: "flex",
            justifyContent: "flex-end",
            gap: 3,
          }}
        >
          <Button
            variant="outlined"
            onClick={() => assignToDeleteOrg("")}
            disabled={isDeleting}
            sx={{
              borderRadius: 14,
              border: "1px solid #336B87",
              color: "#336B87",
              "&:hover": {
                backgroundColor: "#336B87",
                color: "#EEF3F6",
              },
            }}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            sx={{ background: "#336B87" }}
            disabled={isDeleting}
            onClick={handleDelete}
          >
            Confirmar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteOrgModal;
